<template>
  <Dialog
    :header="$t('handover_confirmation')"
    v-model:visible="showApprovalConfirmationModal"
    :closeOnEscape="false"
    :closable="false"
    :modal="true"
    :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
    :style="{ width: '50vw' }"
  >
    <div>
      {{ this.$t("message.handover_confirmation") }}
      <!-- 
            <ul v-for="(doc) in selectedDocuments" v-bind:key="doc.id">
               <li>{{doc.ref_no}}</li> 
            </ul> -->

      <div v-if="!processed"></div>
      <div v-else></div>
    </div>

    <template #footer>
      <div v-if="processed">
        <Button label="Close" @click="dismissConfirmation" />
      </div>
      <div v-else>
        <div v-if="processing" style="float: right !important">
          <ProgressSpinner style="width: 50px; height: 50px" />
        </div>
        <div v-else>
          <div v-if="!processed">
            <Button label="No" @click="dismissConfirmation" />
            <Button
              label="Yes"
              autofocus
              @click="confirmHandover"
              class="pi-button p-button-success"
            />
          </div>
          <div v-else>
            <Button
              label="Close"
              icon="pi pi-times"
              class="p-button-text"
              @click="onClose"
            />
          </div>
        </div>
      </div>
    </template>
  </Dialog>

  <form id="mainForm" action="#" method="post">
    <Card>
      <template #title>
        <Toolbar>
          <template #left>
            <div class="p-card-title">Handover</div>
          </template>

          <template #right>
            <ConfirmPopup></ConfirmPopup>
          </template>
        </Toolbar>
      </template>
      <template #content>
        <div class="p-inputtext-sm p-fluid">
          <Message severity="info" :closable="false">
            <table>
              <tr>
                <td><b>Direction!</b></td>
              </tr>
              <tr>
                <td>
                  This function is only utilized in situations where an account
                  has been resigned or terminated, there by necessitating a
                  transfer of authorization/approval.
                </td>
              </tr>
            </table>
          </Message>
          <div class="grid">
            <div class="col-12">
              <FormField
                :labelName="$t('type')"
                fieldName="Type"
                v-model="headerHandover"
                labelClass="col-4"
                fieldClass="col-6 md-6"
                :required="true"
              >
                <CustomSelect
                  v-model="headerHandover.type"
                  :url="$API_URL + 'list/lookup'"
                  :minLength="0"
                  :filter="true"
                  :params="{ group: 'HANDOVER_TYPE', allow_all: false }"
                />
              </FormField>
              <FormField
                :labelName="$t('existing_pic')"
                fieldName="ExisitingPIC"
                v-model="headerHandover"
                labelClass="col-4"
                fieldClass="col-6 md-6"
                :required="true"
              >
                <CustomSelect
                  v-model="headerHandover.existingPIC"
                  :url="this.$API_URL + 'list/user'"
                  :minLength="0"
                  :filter="true"
                  :params="{}"
                />
              </FormField>
              <FormField
                :labelName="$t('new_pic')"
                fieldName="NewPIC"
                v-model="headerHandover"
                labelClass="col-4"
                fieldClass="col-6 md-6"
                :required="true"
              >
                <CustomSelect
                  v-model="headerHandover.newPIC"
                  :url="this.$API_URL + 'list/user'"
                  :minLength="0"
                  :filter="true"
                  :params="{}"
                />
              </FormField>
            </div>
          </div>
        </div>
        <Button type="button" label="Generate" @click="showData()" />
        &nbsp;
        <Button
          type="button"
          class="p-button-success"
          label="Handover"
          @click="reopenTab()"
          v-show="this.reportTbl"
        />
      </template>
    </Card>
  </form>

  <Card class="mt-4" v-if="this.visibleDocument">
    <template #title>
      <Toolbar>
        <template #left>
          <div class="p-card-title">
            List Document

            <Button
              icon="pi pi-refresh"
              class="p-button-rounded p-button-info p-button-outlined ml-2"
              @click="showData"
            />
          </div>
        </template>

        <template #right>
          <Button
            class="pi-button p-button-success"
            :label="$t('handover')"
            v-if="selectedRow != null && selectedRow.length > 0"
            @click="processSelectedData()"
          />
        </template>
      </Toolbar>
    </template>
    <template #content>
      <div class="p-fluid mb-3">
        <CustomSelectButton
          v-model="selectedStatus"
          :options="statusList"
          optionLabel="option"
          class="p-text-center"
          @change="onStatusChange"
          :setDefault="true"
        >
          <template #option="slotProps">
            <div class="p-text-center" style="width: 100%">
              {{ slotProps.option }}
            </div>
          </template>
        </CustomSelectButton>
      </div>

      <DataTable
        ref="dt"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        filterDisplay="row"
        sortMode="multiple"
        removableSort
        stateStorage="local"
        :stateKey="stateKey"
        :value="dataModel"
        :loading="!dataModel || loading"
        :paginator="true"
        :rows="pageSize"
        :lazy="true"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        v-model:first="this.start"
        @state-restore="onStateRestore($event)"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        @update:selection="onSelect($event)"
        @row-dblclick="onRowDoubleClick"
        v-model:filters="filters"
        :totalRecords="totalRecords"
        v-model:selection="selectedRow"
        selectionMode="multiple"
        dataKey="Id"
        :metaKeySelection="false"
      >
        <Column :exportable="false" :sortable="false" headerStyle="width: 1rem">
          <template #header="">
            <!-- <Button v-if="canCreate" label="Create" icon="pi pi-plus" class="p-button-primary p-button-sm" @click="editor(this.$FORM_MODE_CREATE, 0)" /> -->
          </template>
          <template #filter>
            <Button
              :label="$t('clear')"
              icon="pi pi-filter-slash"
              class="p-button-outlined p-button-primary p-button-sm"
              @click="clearFilter"
              :badge="filterBadge"
              badgeClass="p-badge-danger"
            />
          </template>
        </Column>
        <Column key="Id">
          <template #filter>
            <Checkbox
              v-model="this.isSelectAll"
              @change="SelectAll()"
              :binary="true"
            />
          </template>
        </Column>
        <Column field="DocNumber" :header="$t('doc_no')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('doc_no')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="DocCompany" :header="$t('doc_company')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('status')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="DocVendor"
          :header="$t('doc_vendor')"
          :sortable="true"
          v-if="this.headerHandover.type != 'APPROVAL'"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('status')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="DocCreatedBy"
          :header="$t('doc_createdby')"
          :sortable="true"
          v-if="this.headerHandover.type != 'APPROVAL'"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('status')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="DocOwner" :header="$t('doc_owner')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('status')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="DocStatus" :header="$t('status')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('status')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="DocMode"
          :header="$t('doc_mode')"
          :sortable="true"
          v-if="this.headerHandover.type == 'APPROVAL'"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('doc_mode')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="DocRole"
          :header="$t('doc_role')"
          :sortable="true"
          v-if="this.headerHandover.type == 'APPROVAL'"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('doc_role')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Category"
          :header="$t('category')"
          :sortable="true"
          v-if="this.headerHandover.type == 'APPROVAL'"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('category')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="DocDate"
          :header="$t('doc_date')"
          dataType="date"
          :sortable="true"
          v-if="this.headerHandover.type != 'APPROVAL'"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              :placeholder="$t('doc_date')"
              @date-select="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDate(data.DocDate) }}
          </template>
        </Column>
        <template #expansion="slotProps">
          <div class="orders-subtable">
            <DataTable
              :value="slotProps.data.Details"
              class="w-screen-70"
              v-if="suspension"
            >
              <Column field="Dept_Code" :header="$t('code')" />
              <Column field="Dept_Name" :header="$t('name')" />
            </DataTable>
          </div>
        </template>
      </DataTable>
    </template>
  </Card>
</template>

<script>
import moment from "moment";
import { ref, watch } from "vue";
export default {
  name: "Editor",
  data() {
    return {
      indexName: "HandoverIndex",
      url: this.$API_URL + "handover/",
      handoverUrl: "handover/process",
      userTimeZoneOffset: moment().utcOffset() / 60,
      timezoneUserOffset: this.$store.getters.getTimezoneOffset,
      header: null,
      detail: null,
      mode: "",
      id: 0,
      qrData: null,
      imgOpenModel: [],
      imgCloseModel: [],
      docJseaModel: [],
      docClosePermitModel: [],
      workNumber: null,
      formEditable: true,
      companyCodeUser: this.$store.getters.getCompanyCode,
      companyIdUser: this.$store.getters.getCompanyId,
      idUser: this.$store.getters.getUserId,
      userName: this.$store.getters.getUsername,
      viewFileOpens: [],
      viewFileCloses: [],
      viewFileClosePermits: [],
      viewFileJseaHeader: [],
      headerHandover: {
        existingPIC: null,
        newPIC: null,
        type: null,
      },
      statuswork: null,
      submitted: false,
      dataModelWorkLogs: null,
      dataModelRelease: null,
      dataModelJseaLog: null,
      showInitMtc: null,
      statusWork: "",
      workUser: "",
      isMtcWork: "N",
      fileUrlView: null,
      fileUrl: null,
      fileName: null,
      fileTypeView: null,
      fileHref: null,
      sectionFile: null,
      isImg: false,
      isPdf: false,
      dialogVisibleView: false,
      visibleDocument: false,
      sorts: null,
      lazyParams: {},
      filters: null,
      workData: null,
      stateFilters: null,
      showModal: false,
      methodExecuted: false,
      showFilter: false,
      isIndividual: false,
      isCollective: false,
      isRelation: false,
      driverModels: [],
      dataModel1: null,
      orderData: null,
      orderShipmentData: null,
      driverModel: null,
      dataUrl: "handover/list_document",
      blocked: false,
      transporter: "",
      location: "",
      showApprovalConfirmationModal: false,
      selectedRow: null,
      dataModel: null,
      loading: true,
      totalRecords: 0,
      start: 0,
      pageSize: 10,
      processed: false,
      processing: false,
      isSelectAll: false,
      stateKey:
        this.$STATE_NAME + "handoiver-" + this.$store.getters.getUsername,
    };
  },
  methods: {
    hideRow(data) {
      return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
    },
    showData() {
      if (
        this.headerHandover.type == null ||
        this.headerHandover.existingPIC == null ||
        this.headerHandover.newPIC == null
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Can't Generate",
          detail: "Please fill in all fields.",
          life: 3000,
        });
        return;
      }

      this.visibleDocument = true;
      this.loading = true;
      this.selectedRow = null;
      this.blocked = true;
      this.isSelectAll = false;

      this.lazyParams = {
        start: this.start,
        sorts: this.dataSort,
        filters: this.dataFilter,
        category: this.headerHandover.existingPIC,
        type: this.headerHandover.type,
      };

      var self = this;

      this.$axios
        .post(this.$API_URL + this.dataUrl, this.lazyParams)
        .then((response) => {
          if (response.data.success) {
            //console.log(response.data.data)
            self.dataModel = response.data.data;
            self.dataModel1 = response.data.data;
            self.totalRecords = response.data.totalRecords;
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
          self.blocked = false;
          self.loading = false;
          self.showFilter = true;
        })
        .catch(function (err) {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 3000,
          });
          self.loading = false;
          self.blocked = false;
        });
    },
    onPage(event) {
      this.start = event.first;
      this.showData();
    },
    onSort(event) {
      this.sorts = event.multiSortMeta;
      this.showData();
    },
    onFilter() {
      this.showData();
    },
    onSelect(event) {
      this.selectedRow = event.data;
    },
    onRowExpand(event) {
      this.expandedRows = [];
      this.expandedRows.push(event.data);
    },
    checkRemarks() {
      var result = false;

      var self = this;
      self.invalid = false;

      if (!this.selectedStatus.toLowerCase().includes("appointment")) {
        return false;
      }

      if (this.confirmationStatus == this.$APPROVAL_STATUS.APPROVED) {
        return false;
      }

      for (var x = 0; x < this.selectedRow.length; x++) {
        var doc = this.selectedRow[x];

        if (
          (doc.Remarks == "" || doc.Remarks == null || !doc.Remarks) &&
          this.confirmationStatus != this.$APPROVAL_STATUS.APPROVED
        ) {
          self.invalid = true;
          result = true;
          break;
        }
      }

      return result;
    },
    blockUI() {
      this.$emit("block-ui");
    },
    unblockUI() {
      this.$emit("unblock-ui");
    },
    hideViewer() {
      this.dialogVisibleView = false;
      this.fileUrl = null;
      this.fileName = null;
      this.fileTypeView = null;
      this.fileHref = null;
      this.isImg = false;
      this.isPdf = false;
    },
    showError(summary, message) {
      this.$emit("unblock-ui");
      this.$toast.add({
        severity: "error",
        summary: summary,
        detail: message,
        life: 3000,
      });
    },
    processSelectedData(status) {
      this.showApprovalConfirmationModal = true;
      this.confirmationStatus = status;
    },
    backToIndex() {
      this.$router.push({ path: "/Work/Index" });
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    confirm(event) {
      this.submitted = true;
      if (this.docJseaModel.length != 0) {
        if (!this.header.JseaTitle || !this.header.JseaDescription) {
          return false;
        } else {
          this.$confirm.require({
            target: event.currentTarget,
            message: "Are you sure?",
            icon: "pi pi-exclamation-triangle",
            accept: () => {
              this.saveData();
            },
            reject: () => {
              //callback to execute when user rejects the action
            },
          });
        }
      } else {
        this.$confirm.require({
          target: event.currentTarget,
          message: "Are you sure?",
          icon: "pi pi-exclamation-triangle",
          accept: () => {
            this.saveData();
          },
          reject: () => {
            //callback to execute when user rejects the action
          },
        });
      }
    },
    setFilters() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var filterValue = null;
        if (this.stateFilters) {
          var field = this.stateFilters[exportable[i].props.field];
          if (field) filterValue = field.value;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
    },
    clearFilter() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var fieldName = exportable[i].props.field;
        var filterValue = "";
        if (fieldName.includes("Date")) {
          filterValue = null;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
      this.showData();
    },
    onStateRestore(event) {
      this.start = event.first;
      this.stateFilters = event.filters;
      this.sorts = event.multiSortMeta;
    },
    confirmHandover() {
      if (
        this.headerHandover.type == null ||
        this.headerHandover.existingPIC == null ||
        this.headerHandover.newPIC == null
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Can't Generate",
          detail: "Please fill in all fields.",
          life: 3000,
        });
        return;
      }

      var self = this;

      self.invalid = false;

      var data = {
        data: this.selectedDocuments,
        type: this.headerHandover.type,
        existing_pic: this.headerHandover.existingPIC,
        new_pic: this.headerHandover.newPIC,
      };

      self.processing = true;

      this.$axios
        .put(this.$API_URL + this.handoverUrl, data)
        .then((response) => {
          self.processed = true;
          self.processing = false;
          if (response.data.success) {
            self.$toast.add({
              severity: "success",
              summary: "Hand Over Success",
              detail: response.data.message,
              life: 3000,
            });
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .catch(function (error) {
          self.processed = false;
          self.processing = false;
          console.log("masuk 3");
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 3000,
          });
        });
    },
    SelectAll() {
      console.log(this.isSelectAll);
      if (this.isSelectAll) {
        console.log(this.selectedRow);
        this.selectedRow = this.dataModel1;
      } else {
        this.selectedRow = null;
      }
    },
    dismissConfirmation() {
      this.processed = false;
      this.invalid = false;
      this.showApprovalConfirmationModal = false;
      this.showData();
    },
  },
  created() {
    this.mode = this.$route.query.mode;
    this.id = this.$route.query.id ?? 0;
  },
  mounted() {
    // Watch for changes in loadedData
    watch(
      () => this.dataModel,
      (newValue, oldValue) => {
        if (newValue !== oldValue && !this.methodExecuted) {
          // Data has changed, execute your method
          this.setFilters();
          this.methodExecuted = true;
        }
      }
    );
  },
  computed: {
    dataFilter() {
      var h = [];
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          h.push({
            field: key ? key : null,
            value: value.value,
            matchMode: value.matchMode,
          });
        }
      }
      return h;
    },
    dataSort() {
      var h = [];
      if (this.sorts) {
        for (var x = 0; x < this.sorts.length; x++) {
          h.push({
            field: this.sorts[x].field,
            order: this.sorts[x].order == 1 ? "ASC" : "DESC",
          });
        }
      }
      return h;
    },
    selectedDocuments() {
      var data = [];
      if (this.selectedRow == null) return data;

      for (var x = 0; x < this.selectedRow.length; x++) {
        var row = this.selectedRow[x];
        var d = {
          id: row.Id,
          remarks: row.Remarks,
          ref_no: row.ReferenceNo,
        };

        data.push(d);
      }

      return data;
    },
    canEdit() {
      return (
        this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT
      );
    },
  },
};
</script>
